import { css } from '@emotion/react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { MAX_WIDTH } from './constants';

type TimezoneProps = {
  locationId: string;
};

export const ScheduleAvailabilityHoursTimezoneHeader = ({ locationId }: TimezoneProps) => {
  const { t } = useTranslation('schedule');
  const { locationTimezoneMap } = SchedulerV3.Helpers.useScheduleLocationTimezoneShallowStore('locationTimezoneMap');
  const locationTimeZone = locationTimezoneMap?.[locationId]?.timezone;

  if (!locationTimeZone) return null;

  return (
    <section css={timezoneStyles}>
      <Text weight='bold'>{t('Timezone')}</Text>
      <Text size='large' css={{ flex: 1, maxWidth: 345 }}>
        {locationTimeZone}
      </Text>
    </section>
  );
};

const timezoneStyles = css({
  maxWidth: MAX_WIDTH,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderBottom: `thin solid ${theme.colors.neutral20}`,
});
